export default __webpack_public_path__ + "static/media/plus icon.654d1143.svg";